export default {
  title: {
    en: 'Cancel your {monthsDuration, plural, one {one month} two {two months} other {three months}} break',
  },
}
